import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

export const OuterContainer = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.coolGray.cool200};
`

export const InnerContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`

export const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`

export const Paragraph = styled.strong<{
  textColor: string
}>`
  color: ${(props) => props.textColor};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
`

export const Button = styled(PrimaryButton)<{
  ctaBackgroundColor: string
  ctaTextColor: string
}>`
  background-color: ${(props) => props.ctaBackgroundColor};
  color: ${(props) => props.ctaTextColor};
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  &:disabled {
    background-color: ${(props) => props.ctaBackgroundColor};
  }
`

export const UnavailableText = styled.strong`
  display: block;
  color: ${({ theme }) => theme.colors.coolGray.cool500};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
`
